import { render, staticRenderFns } from "./StocksPage.vue?vue&type=template&id=5fdb53a4&scoped=true"
import script from "./StocksPage.vue?vue&type=script&lang=js"
export * from "./StocksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdb53a4",
  null
  
)

export default component.exports